import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';

// Shown at the top of Analytical mode when the screen is phone-sized: Analytical
// is built for a wide layout, so we suggest Simple (and offer a one-tap switch).
const ModeNudge = () => {
  const { setMode } = useAuth();
  const { COLORS } = useTheme();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div style={{ background: COLORS.amberGlow || COLORS.accentGlow, borderBottom: `1px solid ${COLORS.amber}44`, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10, fontFamily: "'DM Sans', sans-serif" }}>
      <span style={{ fontSize: 18 }}>📱</span>
      <span style={{ color: COLORS.text, fontSize: 13, flex: 1, lineHeight: 1.4 }}>
        Analytical mode is best on a desktop or larger screen. On your phone, <b>Simple</b> mode works better.
      </span>
      <button
        onClick={() => setMode('simple')}
        style={{ background: COLORS.accent, color: '#fff', border: 'none', borderRadius: 6, padding: '6px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' }}
      >
        Switch to Simple
      </button>
      <button
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        style={{ background: 'transparent', border: 'none', color: COLORS.textMuted, fontSize: 18, cursor: 'pointer', lineHeight: 1, padding: '0 4px' }}
      >
        ×
      </button>
    </div>
  );
};

export default ModeNudge;
